import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, useText } from "@sveabank/cc-common";
import type React from "react";

type Props = {
	isOpen: boolean;
	onClose: () => void;
};

const GuarantorSuccessModal: React.FC<Props> = ({ isOpen, onClose }) => {
	const [t, texts] = useText();
	return (
		<Dialog
			isDismissable={false}
			isOpen={isOpen}
			center
			size="small"
			heading={t(texts.signPage.agreementSuccessModal.title)}
			icon="success"
		>
			<Dialog.Content>
				{t(texts.signPage.agreementSuccessModal.descriptionGuarantor)}
			</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup>
					<Button onPress={onClose} width="full">
						{t(texts.common.continue)}
					</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};
export default GuarantorSuccessModal;
